export default __webpack_public_path__ + "static/media/face-with-rolling-eyes.9ec446f2.svg";